// Copyright (c) 2017 Deere & Company

import DealerHierarchyLeadAccount from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-lead-account';
import t from 'tcomb';

const FilteredTerritories = t.list(DealerHierarchyLeadAccount, 'FilteredTerritories');

export const getDefaultState = () => new FilteredTerritories([]);

export default FilteredTerritories;



// WEBPACK FOOTER //
// ./src/tcsm/shared/state/audit-filtered-territories.js